/**
 * Subcategory sections with product grids
 *
 * Renders each subcategory heading + ProductCard grid
 * using UiBlocks ProductCard with AddToCartButton from Checkout.
 * Products are pre-transformed via mapGraphQLProductToProduct.
 */

import { AddToCartButton } from '../../../Checkout'
import { ProductCard, SectionHeader } from '../../../UiBlocks'
import { useBlackFriday } from '../../state'

import type { Product } from '../../../UiBlocks'

export function SubCategorySection() {
  const { selectedCategory } = useBlackFriday()

  if (!selectedCategory) return null

  return (
    <div className="mt-5">
      {selectedCategory.children.map((subCategory) => {
        if (subCategory.products.length === 0) return null

        return (
          <div key={subCategory.id}>
            <SectionHeader
              as="h2"
              size="xl"
              className="react-css mb-7 mt-10 p-5 tracking-wide text-white bg-transparent md:text-center font-bold"
            >
              {subCategory.name}
            </SectionHeader>

            <div className="grid grid-cols-2 gap-6 xl:grid-cols-4">
              {subCategory.products.map((product) => (
                <ProductCard
                  key={product.id}
                  product={product}
                  priceSuffix="Lei"
                  renderActions={(p: Product) => <AddToCartButton sku={p.sku} />}
                />
              ))}
            </div>
          </div>
        )
      })}
    </div>
  )
}
